module.exports = __webpack_public_path__ + "static/img/template_img_06.a6067a03.jpg";